"use strict";

exports.__esModule = true;
exports.SocialLinksList = exports.Resources = exports.ResourceListHeading = exports.ResourceList = exports.ResourceLink = exports.NewsletterHeader = exports.Newsletter = exports.Link = exports.IconContainer = exports.HyVeeLogoLink = exports.FooterLinks = exports.FooterLink = exports.Footer = exports.Disclaimer = exports.Copyright = exports.Branding = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _themes = require("@hy-vee/themes");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Footer = _styledComponents.default.footer.withConfig({
  displayName: "styles__Footer",
  componentId: "c1m51w-0"
})(["background-color:#373131;color:#fff;text-align:center;"]);
exports.Footer = Footer;
const Resources = _styledComponents.default.section.withConfig({
  displayName: "styles__Resources",
  componentId: "c1m51w-1"
})(["background-color:#3d3736;padding:40px 0;width:100%;@media (max-width:1200px){padding:", " 0;}"], _themes.spacing.small);
exports.Resources = Resources;
const IconContainer = _styledComponents.default.span.withConfig({
  displayName: "styles__IconContainer",
  componentId: "c1m51w-2"
})(["padding-left:", ";display:flex;align-self:center;"], _themes.spacing.extraSmall);
exports.IconContainer = IconContainer;
const Newsletter = _styledComponents.default.section.withConfig({
  displayName: "styles__Newsletter",
  componentId: "c1m51w-3"
})(["background-color:#fff;border-top:1px solid ", ";color:", ";padding:", ";a{margin-left:", ";font-size:", ";}"], _themes.colors.grey[200], _themes.colors.grey[500], _themes.spacing.large, _themes.spacing.extraSmall, _themes.sizing[16]);
exports.Newsletter = Newsletter;
const NewsletterHeader = _styledComponents.default.span.withConfig({
  displayName: "styles__NewsletterHeader",
  componentId: "c1m51w-4"
})(["font-weight:normal;margin-right:", ";"], _themes.spacing.small);
exports.NewsletterHeader = NewsletterHeader;
const Branding = _styledComponents.default.section.withConfig({
  displayName: "styles__Branding",
  componentId: "c1m51w-5"
})(["padding:40px 0 ", ";text-align:center;"], _themes.spacing.large);
exports.Branding = Branding;
const FooterLinks = _styledComponents.default.ul.withConfig({
  displayName: "styles__FooterLinks",
  componentId: "c1m51w-6"
})(["list-style:none;@media (max-width:1200px){padding:0;}"]);
exports.FooterLinks = FooterLinks;
const FooterLink = _styledComponents.default.li.withConfig({
  displayName: "styles__FooterLink",
  componentId: "c1m51w-7"
})(["display:inline-block;margin-right:", ";text-transform:capitalize;@media (max-width:1200px){display:block;margin:", " 0;}a{color:", ";font-size:", ";font-weight:400;text-decoration:none;:hover{color:", ";}}"], _themes.spacing.large, _themes.spacing.small, props => props.inverse ? _themes.colors.grey[400] : '#ddd', _themes.sizing[12], props => props.inverse ? _themes.colors.grey[500] : '#fff');
exports.FooterLink = FooterLink;
const Copyright = _styledComponents.default.span.withConfig({
  displayName: "styles__Copyright",
  componentId: "c1m51w-8"
})(["color:", ";font-size:", ";font-weight:300;"], props => props.inverse ? _themes.colors.grey[400] : '#aaa', _themes.sizing[12]);
exports.Copyright = Copyright;
const HyVeeLogoLink = _styledComponents.default.a.withConfig({
  displayName: "styles__HyVeeLogoLink",
  componentId: "c1m51w-9"
})(["font-size:0;svg{display:block;margin:40px auto ", ";}"], _themes.spacing.small);
exports.HyVeeLogoLink = HyVeeLogoLink;
const SocialLinksList = _styledComponents.default.ul.withConfig({
  displayName: "styles__SocialLinksList",
  componentId: "c1m51w-10"
})(["padding:0 0 40px;"]);
exports.SocialLinksList = SocialLinksList;
const Link = _styledComponents.default.li.withConfig({
  displayName: "styles__Link",
  componentId: "c1m51w-11"
})(["display:inline-block;margin:0 ", ";"], _themes.spacing.medium);
exports.Link = Link;
const ResourceList = _styledComponents.default.nav.withConfig({
  displayName: "styles__ResourceList",
  componentId: "c1m51w-12"
})(["display:inline-block;margin:0 auto;padding:0 ", ";text-align:left;vertical-align:top;ul{margin:0;padding:0;}@media (max-width:1200px){margin:10px 0;text-align:center;width:100%;padding:0;}"], _themes.spacing.large);
exports.ResourceList = ResourceList;
const ResourceListHeading = _styledComponents.default.h3.withConfig({
  displayName: "styles__ResourceListHeading",
  componentId: "c1m51w-13"
})(["font-size:", ";font-weight:normal;margin-bottom:", ";text-transform:capitalize;"], _themes.sizing[16], _themes.spacing.small);
exports.ResourceListHeading = ResourceListHeading;
const ResourceLink = _styledComponents.default.li.withConfig({
  displayName: "styles__ResourceLink",
  componentId: "c1m51w-14"
})(["list-style:none;margin-bottom:", ";text-align:left;@media (max-width:1200px){text-align:center;}a{color:#ddd;font-size:", ";font-weight:200;text-decoration:none;:hover{color:#fff;}}"], _themes.spacing.small, _themes.sizing[14]);
exports.ResourceLink = ResourceLink;
const Disclaimer = _styledComponents.default.section.withConfig({
  displayName: "styles__Disclaimer",
  componentId: "c1m51w-15"
})(["background-color:#f5f5f5;border-top:1px solid ", ";color:", ";padding:", ";font-style:italic;a{font-size:", ";color:", ";text-decoration:underline;text-decoration-style:dotted;font-weight:700;}a:hover{color:", ";}"], _themes.colors.grey[200], _themes.colors.grey[500], _themes.spacing.large, _themes.sizing[16], _themes.colors.grey[500], _themes.colors.primaryActive);
exports.Disclaimer = Disclaimer;